// =======================
// src/estilos/paginacao.js
// =======================

import { tamanhosControlesGlobais } from "./global";

export const containerPaginacao = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 0.25,
  flexShrink: 0,
};

export const botaoNavegacaoPaginacao = {
  minWidth: "auto",
  height: 32,
  px: 1.1,
  borderRadius: 1,

  color: "#506784",

  fontSize: tamanhosControlesGlobais.paginacao,
  fontWeight: 500,
  textTransform: "none",

  "&:hover": {
    color: "#0767d8",
    backgroundColor: "#edf5fc",
  },

  "&.Mui-disabled": {
    color: "#a9b7c5",
  },

  "& .MuiButton-startIcon": {
    mr: 0.35,
  },

  "& .MuiButton-endIcon": {
    ml: 0.35,
  },
};

export const botaoProximaPaginacao = {
  ...botaoNavegacaoPaginacao,

  color: "#0767d8",

  fontWeight: 600,

  "&:hover": {
    color: "#0767d8",
    backgroundColor: "#eaf4ff",
  },

  "&.Mui-disabled": {
    color: "#a9b7c5",
  },
};

export const botaoNumeroPaginacao = {
  minWidth: 32,
  width: 32,
  height: 32,
  p: 0,

  borderRadius: 1,

  color: "#315d8e",
  backgroundColor: "transparent",

  fontSize: tamanhosControlesGlobais.paginacao,
  fontWeight: 500,
  textTransform: "none",

  boxShadow: "none",

  "&:hover": {
    color: "#0767d8",
    backgroundColor: "#eaf4ff",
    boxShadow: "none",
  },
};

export const botaoNumeroPaginacaoAtivo = {
  ...botaoNumeroPaginacao,

  color: "#ffffff",
  backgroundColor: "#1976d2",

  fontWeight: 700,

  boxShadow: "0 1px 3px rgba(25, 118, 210, 0.18)",

  "&:hover": {
    color: "#ffffff",
    backgroundColor: "#1565c0",

    boxShadow: "0 1px 3px rgba(25, 118, 210, 0.18)",
  },
};

export const reticenciasPaginacao = {
  minWidth: 27,
  height: 32,

  display: "grid",
  placeItems: "center",

  color: "#7b8ea5",

  fontSize: tamanhosControlesGlobais.reticencias,

  userSelect: "none",
};

export const separadorPaginacao = {
  display: "flex",
  alignItems: "center",

  pl: 1.25,

  borderLeft: "1px solid #d5e2ee",
};
